import { Pipe, PipeTransform } from '@angular/core';

/**
 * Ermöglicht dynamisches Benutzen gegebene Pipes.
 *
 * * Benutzung
 *  [ [Pipe1, [arg1, arg2,...]], [Pipe2, [arg1, arg2,...]] ]  - "|Pipe1:arg1:arg2|Pipe2:arg1:arg2"
 *
 * * Beispiel
 *      this.pipes = [[customNumberPipe, '1.0-3'], [percentPipe, []]]
 *      {{value | dynamic:pipes}}
 *
 *  !Beachten: Pipes mussen im Modul als Provider deklarieren werden.
 *
 */
@Pipe({
    name: 'dynamic'
})
export class DynamicPipe implements PipeTransform {
    transform(value: string, pipes: DynamicPipePipes[]): string {
        if (!pipes || !(pipes instanceof Array)) {
            return value;
        }

        pipes.forEach(([pipe, args]) => {
            value = pipe.transform.apply(pipe, [value, ...args]);
        });
        return value;
    }
}

export type DynamicPipePipes = [PipeTransform, string[]];
